import { db, storage } from "./config"
import { collection, addDoc, getDocs, query, where, doc, updateDoc, getDoc } from "firebase/firestore"

export const createWithdraw = async ({ withdrawId, userId, amount }) => {
    try {
        const withdrawRef = collection(db, "withdraws")

        // Add a new document with a generated ID
        const docRef = await addDoc(withdrawRef, {
            withdraw_id: withdrawId,
            user_id: userId,
            created_at: new Date(),
            method,
            amount
        })

        console.log("Document written with ID: ", docRef.id)
    } catch (e) {
        console.error("Error adding document: ", e)
    }
}

export const getWithdrawsByUserId = async (userId) => {
    try {
        const withdrawRef = collection(db, "withdraws");
        const q = query(withdrawRef, where("user_id", "==", userId));
        const querySnapshot = await getDocs(q);

        const withdraws = [];
        querySnapshot.forEach((doc) => {
            withdraws.push({ id: doc.id, ...doc.data() });
        });

        return withdraws; // Returns an array of withdrawal documents
    } catch (e) {
        console.error("Error fetching withdrawals: ", e);
        return []; // Return an empty array on error
    }
}